if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      // Evita abertura fantasma do carrinho em carregamentos/restauração de página.
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      this.bindOverlay();
      this.setHeaderCartIconAccessibility();
      this.addEventListener('click', (event) => {
        const scrollButton = event.target.closest('[data-mf-upsell-scroll]');
        if (scrollButton && this.contains(scrollButton)) {
          this.scrollUpsellTrack(scrollButton);
          return;
        }

        const button = event.target.closest('[data-mf-upsell-add]');
        if (!button || !this.contains(button)) return;
        this.addUpsellItem(button);
      });

      this.addEventListener('change', (event) => {
        const upsellSelect = event.target.closest('[data-mf-upsell-variant-select]');
        if (upsellSelect && this.contains(upsellSelect)) {
          this.updateUpsellVariant(upsellSelect);
          return;
        }

        const giftSelect = event.target.closest('[data-mf-gift-variant]');
        if (giftSelect && this.contains(giftSelect)) this.updateGiftVariant(giftSelect);
      });

      this.addEventListener('input', (event) => {
        const phoneInput = event.target.closest('[data-mf-gift-lead-phone]');
        if (phoneInput && this.contains(phoneInput)) {
          this.applyLeadPhoneMask(phoneInput);
          phoneInput.classList.remove('is-error');
          return;
        }

        const nameInput = event.target.closest('[data-mf-gift-lead-name]');
        if (nameInput && this.contains(nameInput)) nameInput.classList.remove('is-error');
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.queueInteractiveRefresh();
        });
      }

      this.initInteractiveContent();
    }

    bindOverlay() {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (!overlay || overlay.dataset.bound === 'true') return;

      overlay.dataset.bound = 'true';
      overlay.addEventListener('click', () => this.close());
    }

    initInteractiveContent() {
      this.querySelectorAll('[data-mf-upsell-variant-select]').forEach((select) => {
        this.updateUpsellVariant(select);
      });

      this.querySelectorAll('[data-mf-cart-gift]').forEach((offer) => {
        this.initGiftOffer(offer);
      });
    }

    queueInteractiveRefresh() {
      // Algumas atualizações do carrinho substituem o HTML em duas etapas.
      // Repetir a busca garante que o conteúdo interativo final seja inicializado.
      [0, 120, 360].forEach((delay) => {
        window.setTimeout(() => this.initInteractiveContent(), delay);
      });
    }

    normalizeColor(value) {
      const normalized = String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\b(boucle|tecido|cor|premium)\b/g, ' ')
        .replace(/\d+/g, ' ')
        .replace(/[^a-z\s-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      if (normalized.includes('bege claro')) return 'bege claro';
      if (normalized.includes('bege escuro')) return 'bege escuro';
      if (normalized.includes('verde menta')) return 'verde menta';
      if (normalized.includes('laranja')) return 'laranja';
      if (normalized.includes('cinza')) return 'cinza';
      return normalized;
    }

    updateUpsellVariant(select) {
      if (!select) return;
      const card = select.closest('[data-mf-upsell-card]');
      const option = select.options[select.selectedIndex];
      if (!card || !option || option.disabled) return;

      const button = card.querySelector('[data-mf-upsell-add]');
      const image = card.querySelector('[data-mf-upsell-image]');
      const price = card.querySelector('[data-mf-upsell-price]');

      if (button) button.dataset.variantId = option.value;
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
      }
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    }

    updateGiftVariant(select) {
      if (!select) return;
      const offer = select.closest('[data-mf-cart-gift]');
      const option = select.options[select.selectedIndex];
      const image = offer?.querySelector('[data-mf-gift-image]');
      if (image && option?.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
      }
    }

    initGiftOffer(offer) {
      if (!offer || offer.dataset.mfGiftReady === 'true') return;
      offer.dataset.mfGiftReady = 'true';

      const select = offer.querySelector('[data-mf-gift-variant]');
      const sourceColor = this.normalizeColor(offer.dataset.sourceColor || '');
      if (select && sourceColor) {
        const match = Array.from(select.options).find((option) => {
          if (option.disabled) return false;
          const optionColor = this.normalizeColor(option.dataset.title || option.textContent || '');
          return optionColor === sourceColor || optionColor.includes(sourceColor) || sourceColor.includes(optionColor);
        });
        if (match) select.value = match.value;
      }

      this.updateGiftVariant(select);
      const phoneInput = offer.querySelector('[data-mf-gift-lead-phone]');
      if (phoneInput) this.applyLeadPhoneMask(phoneInput);

      const button = offer.querySelector('[data-mf-gift-add]');
      const status = offer.querySelector('[data-mf-gift-status]');
      const badge = offer.querySelector('.mf-cart-gift-offer__badge');
      const hasGift = offer.dataset.hasGift === 'true';

      if (!hasGift && badge) badge.textContent = 'Brinde disponível';
      if (!hasGift && button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Garantir meu porta-copos';
      }
      if (!hasGift && select) select.disabled = false;
      if (!hasGift && status && status.textContent.includes('tempo')) status.textContent = '';
    }

    async cartAlreadyHasCupholder(productId, variantId) {
      try {
        const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        if (!response.ok) return false;
        const cartState = await response.json();
        return (cartState.items || []).some((item) => {
          if (productId && Number(item.product_id || 0) === Number(productId)) return true;
          return variantId && Number(item.variant_id || item.id || 0) === Number(variantId);
        });
      } catch (error) {
        return false;
      }
    }

    setGiftOfferReserved(offer) {
      if (!offer) return;
      offer.dataset.hasGift = 'true';
      offer.classList.add('has-gift');
      const badge = offer.querySelector('.mf-cart-gift-offer__badge');
      const body = offer.querySelector('.mf-cart-gift-offer__body');
      const controls = offer.querySelector('.mf-cart-gift-offer__controls');
      const status = offer.querySelector('[data-mf-gift-status]');
      if (badge) badge.textContent = 'Porta-copos garantido';
      if (body) body.hidden = true;
      if (controls) controls.hidden = true;
      if (status) {
        status.classList.add('mf-cart-gift-offer__status--reserved');
        status.textContent = 'Seu porta-copos já está no carrinho.';
      }
      document.dispatchEvent(new CustomEvent('modifika:gift-state-changed', { detail: { hasGift: true } }));
    }



    cleanLeadName(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 80);
    }

    getLeadPhoneDigits(value) {
      let digits = String(value || '').replace(/\D/g, '');
      if (digits.startsWith('55') && digits.length > 11) digits = digits.slice(2);
      return digits.slice(0, 11);
    }

    formatLeadPhone(value) {
      const digits = this.getLeadPhoneDigits(value);
      if (!digits) return '';
      const ddd = digits.slice(0, 2);
      const ninth = digits.slice(2, 3);
      const first = digits.slice(3, 7);
      const last = digits.slice(7, 11);

      let formatted = '(' + ddd;
      if (digits.length >= 2) formatted += ')';
      if (ninth) formatted += ninth;
      if (first) formatted += ' ' + first;
      if (last) formatted += '-' + last;
      return formatted;
    }

    applyLeadPhoneMask(input) {
      if (!input) return;
      const formatted = this.formatLeadPhone(input.value);
      input.value = formatted;
      input.setAttribute('maxlength', '15');
    }

    normalizeLeadPhone(value) {
      const formatted = this.formatLeadPhone(value);
      const brDigits = this.getLeadPhoneDigits(formatted);
      const whatsapp = brDigits ? `+55${brDigits}` : '';

      return {
        original: formatted,
        digits: brDigits,
        brDigits,
        whatsapp,
        isValid: brDigits.length === 11 && brDigits.charAt(2) === '9',
      };
    }

    getGiftLeadData(offer) {
      const nameInput = offer?.querySelector('[data-mf-gift-lead-name]');
      const phoneInput = offer?.querySelector('[data-mf-gift-lead-phone]');
      const name = this.cleanLeadName(nameInput?.value);
      if (phoneInput) this.applyLeadPhoneMask(phoneInput);
      const phone = this.normalizeLeadPhone(phoneInput?.value);

      [nameInput, phoneInput].forEach((input) => input?.classList.remove('is-error'));

      if (!name || name.length < 2) {
        nameInput?.classList.add('is-error');
        return {
          isValid: false,
          message: 'Informe seu nome para resgatar o prêmio.',
          focus: nameInput,
        };
      }

      if (!phone.isValid) {
        phoneInput?.classList.add('is-error');
        return {
          isValid: false,
          message: 'Digite o WhatsApp no formato (DD)9 9999-9999.',
          focus: phoneInput,
        };
      }

      return {
        isValid: true,
        name,
        phoneOriginal: phone.original,
        phoneDigits: phone.digits,
        phoneBrDigits: phone.brDigits,
        phoneWhatsapp: phone.whatsapp,
      };
    }

    getLeadWebhookUrl(offer) {
      return String(
        offer?.dataset?.leadsWebhookUrl ||
          window.MODIFIKA_CART_LEADS_WEBHOOK_URL ||
          'https://script.google.com/macros/s/AKfycbwb4T_5rpQVh-aStAlSRa1CnRQyToBujJP3qTSsY59HhnyO-xDaGJjhXML0Aofw4Qaa4Q/exec'
      ).trim();
    }

    getUtmData() {
      const params = new URLSearchParams(window.location.search || '');
      const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
      const data = {};

      keys.forEach((key) => {
        let value = params.get(key) || '';
        try {
          const stored = window.localStorage.getItem(`modifika_${key}`) || '';
          if (!value && stored) value = stored;
          if (value) window.localStorage.setItem(`modifika_${key}`, value);
        } catch (error) {
          // Mantém UTMs da URL mesmo sem localStorage.
        }
        data[key] = value;
      });

      return data;
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `R$ ${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
      }
    }

    async getCartStateForLead() {
      try {
        const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        if (!response.ok) throw new Error('Não foi possível ler o carrinho.');
        return await response.json();
      } catch (error) {
        console.warn('Modifika: falha ao coletar carrinho para lead.', error);
        return null;
      }
    }

    buildGiftLeadPayload(offer, leadData, selectedOption, deadline, cartState) {
      const cartItems = Array.isArray(cartState?.items) ? cartState.items : [];
      const mainItem = cartItems.find((item) => {
        const title = String(item.product_title || item.title || '').toLowerCase();
        const handle = String(item.handle || item.product_handle || '').toLowerCase();
        if (item.properties?._mf_gift === '1') return false;
        if (title.includes('porta-copos') || title.includes('porta copos') || title.includes('porta-copo')) return false;
        if (handle.includes('porta-copos') || handle.includes('porta-copo')) return false;
        if (title.includes('capa')) return false;
        return true;
      }) || cartItems[0] || null;

      const itemsResumo = cartItems
        .map((item) => `${item.quantity || 1}x ${item.product_title || item.title || 'Produto'}${item.variant_title ? ` - ${item.variant_title}` : ''}`)
        .join(' | ');

      const utms = this.getUtmData();
      const eventId = `MF-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const giftColor = selectedOption?.dataset?.title || selectedOption?.textContent?.trim() || '';

      return {
        event_id: eventId,
        origem: 'Carrinho lateral - brinde porta-copos',
        data_iso: new Date().toISOString(),
        nome: leadData.name,
        whatsapp: leadData.phoneWhatsapp,
        whatsapp_formatado: leadData.phoneOriginal,
        whatsapp_digitado: leadData.phoneOriginal,
        whatsapp_digitos: leadData.phoneDigits,
        produto_principal: mainItem?.product_title || mainItem?.title || '',
        variante_principal: mainItem?.variant_title || '',
        cor_brinde: giftColor,
        status_brinde: 'Solicitado no carrinho',
        total_carrinho_centavos: cartState?.total_price || 0,
        total_carrinho: this.formatMoney(cartState?.total_price || 0),
        qtd_itens: cartState?.item_count || cartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0),
        itens_resumo: itemsResumo,
        pagina: window.location.href,
        produto_url: mainItem?.url ? new URL(mainItem.url, window.location.origin).href : window.location.href,
        cart_token: cartState?.token || offer?.dataset?.cartToken || '',
        gift_deadline: deadline || '',
        consentimento: 'Aceitou contato sobre este carrinho ao garantir o prêmio',
        user_agent: window.navigator.userAgent,
        utm_source: utms.utm_source || '',
        utm_medium: utms.utm_medium || '',
        utm_campaign: utms.utm_campaign || '',
        utm_content: utms.utm_content || '',
        utm_term: utms.utm_term || '',
        items: cartItems.map((item) => ({
          product_id: item.product_id,
          variant_id: item.variant_id || item.id,
          title: item.product_title || item.title,
          variant: item.variant_title || '',
          quantity: item.quantity,
          price: item.price,
          final_line_price: item.final_line_price,
          url: item.url,
        })),
      };
    }

    async saveCartLeadAttributes(payload) {
      const attributes = {
        'Lead - Nome': payload.nome || '',
        'Lead - WhatsApp': payload.whatsapp || '',
        'Lead - WhatsApp formatado': payload.whatsapp_formatado || '',
        'Lead - Origem': payload.origem || '',
        'Lead - Produto principal': payload.produto_principal || '',
        'Lead - Variante principal': payload.variante_principal || '',
        'Lead - Cor do brinde': payload.cor_brinde || '',
        'Lead - URL da página': payload.pagina || '',
        'Lead - Consentimento': payload.consentimento || '',
        'Lead - Data': payload.data_iso || '',
      };

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ attributes }),
        });
        if (!response.ok) throw new Error(`Status ${response.status}`);
      } catch (error) {
        console.warn('Modifika: não foi possível salvar atributos do lead no carrinho.', error);
      }
    }

    async sendGiftLeadToWebhook(offer, payload) {
      const webhookUrl = this.getLeadWebhookUrl(offer);
      if (!webhookUrl) return;

      try {
        await fetch(webhookUrl, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: {
            'Content-Type': 'text/plain;charset=utf-8',
          },
          body: JSON.stringify(payload),
        });
      } catch (error) {
        console.warn('Modifika: não foi possível enviar lead para Google Sheets.', error);
      }
    }

    async saveGiftLead(offer, leadData, selectedOption, deadline) {
      const cartState = await this.getCartStateForLead();
      const payload = this.buildGiftLeadPayload(offer, leadData, selectedOption, deadline, cartState);

      await Promise.allSettled([
        this.saveCartLeadAttributes(payload),
        this.sendGiftLeadToWebhook(offer, payload),
      ]);

      return payload;
    }

    async addGiftItem(button) {
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      const offer = button.closest('[data-mf-cart-gift]');
      const select = offer?.querySelector('[data-mf-gift-variant]');
      const status = offer?.querySelector('[data-mf-gift-status]');
      const deadline = 0;
      const variantId = Number(select?.value || 0);
      const productId = Number(offer?.dataset.productId || 0);

      if (!offer || !select || !variantId) return;

      const leadData = this.getGiftLeadData(offer);
      if (!leadData.isValid) {
        if (status) status.textContent = leadData.message;
        leadData.focus?.focus();
        return;
      }

      if (await this.cartAlreadyHasCupholder(productId, variantId)) {
        const selectedOption = select.options[select.selectedIndex];
        await this.saveGiftLead(offer, leadData, selectedOption, deadline);
        this.setGiftOfferReserved(offer);
        return;
      }

      const originalText = button.textContent;
      const selectedOption = select.options[select.selectedIndex];
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      select.disabled = true;
      button.textContent = 'Reservando...';
      if (status) status.textContent = 'Salvando seus dados e reservando o prêmio...';

      try {
        const leadPayload = await this.saveGiftLead(offer, leadData, selectedOption, deadline);
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _mf_gift: '1',
                  _mf_gift_color: selectedOption?.dataset.title || selectedOption?.textContent?.trim() || '',
                  _mf_lead_event_id: leadPayload?.event_id || '',
                  Brinde: 'Porta-copos grátis',
                  Cliente: leadData.name,
                  WhatsApp: leadData.phoneWhatsapp,
                  'WhatsApp formatado': leadData.phoneOriginal,
                },
              },
            ],
            sections: this.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          }),
        });

        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Não foi possível adicionar o brinde.');
        this.renderContents(state);
        document.dispatchEvent(new CustomEvent('modifika:gift-state-changed', { detail: { hasGift: true } }));
      } catch (error) {
        console.error(error);
        button.textContent = 'Tentar garantir novamente';
        if (status) status.textContent = 'Não foi possível adicionar o brinde agora. Tente novamente.';
        window.setTimeout(() => {
          if (!button.isConnected) return;
          button.textContent = originalText;
          button.disabled = false;
          select.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1800);
      }
    }

    scrollUpsellTrack(button) {
      const upsell = button.closest('.mf-cart-upsell');
      const track = upsell?.querySelector('.mf-cart-upsell__track');
      if (!track) return;

      const direction = Number(button.dataset.mfUpsellScroll) || 1;
      const card = track.querySelector('.mf-cart-upsell__card');
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 10;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.82;

      track.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    async addUpsellItem(button) {
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      const originalText = button.textContent;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Adicionando...';

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: this.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          }),
        });

        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Não foi possível adicionar.');

        this.renderContents(state);
      } catch (error) {
        console.error(error);
        button.textContent = 'Tente novamente';
        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1800);
      }
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink || cartLink.dataset.drawerBound === 'true') return;

      cartLink.dataset.drawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() !== 'SPACE') return;
        event.preventDefault();
        this.open(cartLink);
      });
    }

    async hydrate() {
      if (this.dataset.lazy !== 'true') return;
      if (this.hydrationPromise) return this.hydrationPromise;

      this.classList.add('is-loading');
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'cart-drawer');
      this.hydrationPromise = fetch(sectionUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Falha ao carregar o carrinho: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incoming = parsed.querySelector('#CartDrawer');
          const current = this.querySelector('#CartDrawer');
          if (!incoming || !current) throw new Error('Conteúdo do carrinho não encontrado.');

          const incomingDrawer = incoming.closest('cart-drawer');
          current.innerHTML = incoming.innerHTML;
          this.dataset.lazy = 'false';
          this.classList.toggle('is-empty', incomingDrawer?.classList.contains('is-empty') === true);
          this.bindOverlay();
          this.queueInteractiveRefresh();
          document.dispatchEvent(new CustomEvent('modifika:cart-sections-rendered'));
        })
        .finally(() => {
          this.classList.remove('is-loading');
          this.hydrationPromise = null;
        });

      return this.hydrationPromise;
    }

    async open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      try {
        await this.hydrate();
      } catch (error) {
        console.error(error);
        window.location.href = window.routes.cart_url;
        return;
      }

      requestAnimationFrame(() => {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
      });

      window.setTimeout(() => {
        const focusContainer = this.querySelector('.drawer__inner');
        const focusTarget = this.querySelector('.drawer__close');

        if (focusContainer && focusTarget) trapFocus(focusContainer, focusTarget);
      }, 240);
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.dataset.lazy = 'false';
      this.classList.remove('is-empty');
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        const sectionMarkup = parsedState.sections && parsedState.sections[section.id];

        if (!sectionElement || !sectionMarkup) return;

        const newContent = this.getSectionInnerHTML(sectionMarkup, section.selector);
        if (typeof newContent === 'string') sectionElement.innerHTML = newContent;
      });

      this.bindOverlay();
      this.queueInteractiveRefresh();
      this.open();

      document.dispatchEvent(
        new CustomEvent('modifika:cart-updated', {
          detail: { itemCount: parsedState.item_count },
        })
      );
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const element = documentFragment.querySelector(selector);
      return element ? element.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

document.addEventListener('modifika:cart-sections-rendered', () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.queueInteractiveRefresh === 'function') {
    drawer.queueInteractiveRefresh();
  }
});

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}
